module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAASBAMAAAB/WzlGAAAAJFBMVEUAAABZWVlVVVVXV1dVVVVVVVVVVVVVVVVWVlZVVVVXV1dVVVW31x3nAAAAC3RSTlMAENsb0srF4CC0I2ATgI0AAABGSURBVAjXYwACxikMICC2CcyJrgBRopsMwBxlEEcEwvEGc0y2GICoaEewpmxnBpgKqBKYbrB2DQh3ewOYm10FswjMncoAAFraDd/6IAztAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/back.png
// module id = 112
// module chunks = 38